import request from '@/utils/request';

export const TRAININGS = 'TRAININGS';
export const CARRIERS_LIST = 'CARRIERS_LIST';

export const fetchTrainings = query => async dispatch => {
  const response = await request({
    path: `/v1/trainings`,
    query
  });
  dispatch({
    payload: response,
    type: TRAININGS
  });
};

export const fetchCarriers =
  (q, additionalDetails = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/carriers`,
      query: { q, ...additionalDetails }
    });
    dispatch({
      payload: response,
      type: CARRIERS_LIST
    });
    return response;
  };

export const createCarrier = name => async () =>
  await request({
    path: `/v1/carriers`,
    method: 'POST',
    body: { name }
  });

export const LEAD_VENDORS_LIST = 'LEAD_VENDORS_LIST';

export const fetchLeadVendors = q => async dispatch => {
  const response = await request({
    path: `/v1/lead_vendors`,
    query: { q }
  });
  dispatch({
    payload: response,
    type: LEAD_VENDORS_LIST
  });
  return response;
};

export const createLeadVendor = name => async () =>
  await request({
    path: `/v1/lead_vendors`,
    method: 'POST',
    body: { name }
  });
